/**
 * RankIcon — shared chief/deputy star indicator.
 *
 *   <RankIcon rank="chief"  size={11} />   → gold star
 *   <RankIcon rank="deputy" size={11} />   → white star
 *   <RankIcon rank="member" />              → renders nothing
 *
 * Designed to be rendered SIDE-BY-SIDE with <PremiumBadge /> so a player
 * who is both a Chief AND a Premium member shows BOTH icons.
 */
import { Star } from "@phosphor-icons/react";

export default function RankIcon({ rank, size = 11, className = "" }) {
  if (rank === "chief") {
    return (
      <Star
        size={size}
        weight="fill"
        className={`text-amber-400 shrink-0 ${className}`}
        title="Chief"
        aria-label="Chief"
        data-testid="rank-chief"
      />
    );
  }
  if (rank === "deputy") {
    return (
      <Star
        size={size}
        weight="fill"
        className={`text-white shrink-0 ${className}`}
        title="Deputy Chief"
        aria-label="Deputy Chief"
        data-testid="rank-deputy"
      />
    );
  }
  return null;
}
